// src/pages/expense/cafe/ExpenseCafeDoksanDraftNew.jsx
// ✅ 전 사업 확산 [5] — 카페인 독산점 "지출데이터+기안 작성" 페이지. 실제 로직은
// pages/expense/_shared/ExpenseDraftNew.jsx(공통 컴포넌트)에 있고, 이 파일은
// 독산점 전용 config(doksanDraftConfig.js)를 넘기는 얇은 래퍼일 뿐이다.
import React from "react";
import ExpenseDraftNew from "../_shared/ExpenseDraftNew";
import doksanDraftConfig from "./doksanDraftConfig";

export default function ExpenseCafeDoksanDraftNew() {
  return <ExpenseDraftNew config={doksanDraftConfig} />;
}
